import { useState, useEffect } from "react";

// Local image preview only; nothing is uploaded while sending attachments is not available.
export function useLocalImage() {
  const [file, setFile] = useState(null);
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (!file) { setUrl(""); return undefined; }
    const u = URL.createObjectURL(file);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [file]);
  return { file, url, pick: (e) => setFile(e.target.files?.[0] || null), clear: () => setFile(null) };
}
